import React from 'react';
import { graphql, useFragment } from 'react-relay';

import {
  PromotionProductEventDescriptionList_promotion$data,
  PromotionProductEventDescriptionList_promotion$key,
} from '../../../relay/__generated__/PromotionProductEventDescriptionList_promotion.graphql';
import { getDurationText } from '../../../utils/date';
import DescriptionList, { DescriptionListProps } from '../../core/DescriptionList';
import Text from '../../core/Text';

const PromotionProductEventDescriptionList_promotion = graphql`
  fragment PromotionProductEventDescriptionList_promotion on Promotion {
    productEvent {
      title

      durationDays
      durationHours
      offsetHours
    }
  }
`;

type Props = {
  promotion: PromotionProductEventDescriptionList_promotion$key;
} & Omit<
  DescriptionListProps<PromotionProductEventDescriptionList_promotion$data>,
  'item' | 'itemDescriptions' | 'picks'
>;
const PromotionDescriptionList = ({ promotion: promotionReference, ...props }: Props) => {
  const promotion = useFragment(PromotionProductEventDescriptionList_promotion, promotionReference);

  return (
    <DescriptionList
      item={promotion}
      itemDescriptions={{
        title: {
          title: '할인 이벤트명',
          renderValue: ({ productEvent }) =>
            productEvent?.title ? <Text fontSize={1}>{productEvent?.title}</Text> : null,
        },
        offset: {
          title: '오프셋',
          renderValue: ({ productEvent }) =>
            productEvent?.offsetHours ? <Text fontSize={1}>{productEvent?.offsetHours}시간</Text> : undefined,
        },
        duration: {
          title: '지속시간',
          renderValue: ({ productEvent }) =>
            typeof productEvent?.durationDays === 'number' || typeof productEvent?.durationHours === 'number' ? (
              <Text fontSize={1}>
                {getDurationText({ days: productEvent?.durationDays, hours: productEvent?.durationHours })}
              </Text>
            ) : undefined,
        },
      }}
      picks={['title', 'offset', 'duration']}
      {...props}
    />
  );
};

export default PromotionDescriptionList;
